export const CATALOG_LOGIN_REQUEST = 'CATALOG_LOGIN_REQUEST'
export const CATALOG_LOGIN_SUCCESS = 'CATALOG_LOGIN_SUCCESS'
export const CATALOG_LOGIN_FAIL = 'CATALOG_LOGIN_FAIL'
export const CATALOG_LOGOUT = 'CATALOG_LOGOUT'

export const CATALOG_REGISTER_REQUEST = 'CATALOG_REGISTER_REQUEST'
export const CATALOG_REGISTER_SUCCESS = 'CATALOG_REGISTER_SUCCESS'
export const CATALOG_REGISTER_FAIL = 'CATALOG_REGISTER_FAIL'



export const CATALOG_DETAILS_REQUEST = 'CATALOGLOGUE_DETAILS_REQUEST'
export const CATALOG_DETAILS_SUCCESS = 'CATALOG_DETAILS_SUCCESS'
export const CATALOG_DETAILS_FAIL = 'CATALOG_DETAILS_FAIL'
export const CATALOG_DETAILS_RESET = 'CATALOG_DETAILS_RESET'

export const CATALOG_UPDATE_PROFILE_REQUEST = 'CATALOG_UPDATE_PROFILE_REQUEST'
export const CATALOG_UPDATE_PROFILE_SUCCESS = 'CATALOG_UPDATE_PROFILE_SUCCESS'
export const CATALOG_UPDATE_PROFILE_FAIL = 'CATALOG_UPDATE_PROFILE_FAIL'

export const CATALOG_LIST_REQUEST = 'CATALOG_LIST_REQUEST'
export const CATALOG_LIST_SUCCESS = 'CATALOG_LIST_SUCCESS'
export const CATALOG_LIST_FAIL = 'CATALOG_LIST_FAIL'
export const CATALOG_LIST_RESET = 'CATALOG_LIST_RESET'

export const CATALOG_DELETE_REQUEST = 'CATALOG_DELETE_REQUEST'
export const CATALOG_DELETE_SUCCESS = 'CATALOG_DELETE_SUCCESS'
export const CATALOG_DELETE_FAIL = 'CATALOG_DELETE_FAIL'

export const CATALOG_UPDATE_REQUEST = 'CATALOG_UPDATE_REQUEST'
export const CATALOG_UPDATE_SUCCESS = 'CATALOG_UPDATE_SUCCESS'
export const CATALOG_UPDATE_FAIL = 'CATALOG_UPDATE_FAIL'
export const CATALOG_UPDATE_RESET = 'CATALOG_UPDATE_RESET'
